module.exports = __webpack_public_path__ + "static/media/contact.797041a0.svg";